import React, { useState, useEffect, useCallback } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";

import ItemService from "../../../services/supplier_appCommonService";
import Layout from "../../../Layout/Layout";
import Constants from "../../../common/SupplierConstants";
import { InputField } from "../../../Components/formElements/InputField";
import { TextAreaField } from "../../../Components/formElements/TextAreaField";
import SuccessModal from "../../../Components/Modal/supplier_app/SuccessModal";
import ConfirmationLoader from "../../../Components/ConfirmationLoader";
import { formatDateTime } from "../../../common/Validations";

const QualityCheckDetails = () => {
  const navigate = useNavigate();
  let qualityCheckNr = useSelector(
    (state) => state?.qualityCheck?.quality_check_detail?.qualityCheckNr
  );
  localStorage.setItem("menu", "Purchasing");
  localStorage.setItem("submenu", "Quality Check Details");

  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [qualityCheckData, setQualityCheckData] = useState(null);
  const [itemTableData, setItemTableData] = useState([]);

  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);
  const [isCardVisible7, setCardVisible7] = useState(true);

  const toggleCardVisibility1 = () => setCardVisible1(!isCardVisible1);
  const toggleCardVisibility2 = () => setCardVisible2(!isCardVisible2);
  const toggleCardVisibility3 = () => setCardVisible3(!isCardVisible3);
  const toggleCardVisibility4 = () => setCardVisible4(!isCardVisible4);
  const toggleCardVisibility5 = () => setCardVisible5(!isCardVisible5);
  const toggleCardVisibility6 = () => setCardVisible6(!isCardVisible6);
  const toggleCardVisibility7 = () => setCardVisible7(!isCardVisible7);


  const [formInputs, setFormInputs] = useState({});
  const [originalFormInputs, setOriginalFormInputs] = useState({});

  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getsucceModalData, setsucceModalData] = useState({
    title: "Message",
    successMsg: "",
  });

  const loadQualityCheckDetail = useCallback(async () => {
    if (!qualityCheckNr) return;
    setLoading(true);
    try {
      let obj = { qualityCheckNr: qualityCheckNr };
      const res = await ItemService.getQualityCheckDetail(obj);
      if (res?.status === 200 && res.data?.length > 0) {
        const data = res.data[0];
        setQualityCheckData(data);
        setFormInputs(data);
        setOriginalFormInputs(data);
        setItemTableData(data.items || []);
      } else {
        toast.error(res?.message || "Quality Check not found");
      }
    } catch (err) {
      console.log("Error loading quality check:", err);
      toast.error("Error loading quality check details");
    }
    setLoading(false);
  }, [qualityCheckNr]);

  useEffect(() => {
    loadQualityCheckDetail();
  }, [loadQualityCheckDetail]);

  const onInputChange = ({ target: { name, value } }) => {
    if (!isEditMode) return;
    setFormInputs((prev) => ({ ...prev, [name]: value }));
  };

  const onItemInputChange = (local_id, fieldName, value) => {
    if (!isEditMode) return;
    setItemTableData((prev) =>
      prev.map((item) => {
        if (item.local_id === local_id) {
          const updated = { ...item, [fieldName]: value };
          if (fieldName === "acceptedQuantity" || fieldName === "inspectionQuantity") {
            const accepted = Number(fieldName === "acceptedQuantity" ? value : item.acceptedQuantity) || 0;
            const inspected = Number(fieldName === "inspectionQuantity" ? value : item.inspectionQuantity) || 0;
            if (inspected > 0) {
              updated.qualityScore = Math.round((accepted / inspected) * 100);
            } else {
              updated.qualityScore = 0;
            }
          }
          return updated;
        }
        return item;
      })
    );
  };

  const handleEdit = () => {
    setIsEditMode(true);
  };

  const handleCancel = () => {
    setIsEditMode(false);
    setFormInputs(originalFormInputs);
    setItemTableData(qualityCheckData?.items || []);
  };

  const handleUpdate = async () => {
    const totalAccepted = itemTableData.reduce((sum, item) => sum + (Number(item.acceptedQuantity) || 0), 0);
    const totalRejected = itemTableData.reduce((sum, item) => sum + (Number(item.rejectedQuantity) || 0), 0);
    const totalInspected = itemTableData.reduce((sum, item) => sum + (Number(item.inspectionQuantity) || 0), 0);
    const overallScore = totalInspected > 0 ? Math.round((totalAccepted / totalInspected) * 100) : 0;

    const updatePayload = {
      qualityCheckNr: qualityCheckData.qualityCheckNr,
      grnNr: qualityCheckData.grnNr,
      purchasingDocumentNr: qualityCheckData.purchasingDocumentNr,
      vendorCode: qualityCheckData.vendorCode,
      vendorName: qualityCheckData.vendorName,
      items: itemTableData,
      inspectionQuantity: totalInspected,
      acceptedQuantity: totalAccepted,
      rejectedQuantity: totalRejected,
      qualityScore: overallScore,
      overallScore: overallScore,
      inspectionDate: formInputs.inspectionDate,
      inspectorName: formInputs.inspectorName,
      inspectionType: formInputs.inspectionType,
      overallResult: formInputs.overallResult,
      inspectionComments: formInputs.inspectionComments,
      inspectionMethod: formInputs.inspectionMethod,
      samplingMethod: formInputs.samplingMethod,
      sampleSize: formInputs.sampleSize,
      testEquipmentUsed: formInputs.testEquipmentUsed,
      temperatureCondition: formInputs.temperatureCondition,
      humidityCondition: formInputs.humidityCondition,
      inspectionNotes: formInputs.inspectionNotes,
      defectDescription: formInputs.defectDescription,
      correctiveAction: formInputs.correctiveAction,
      qualityReportNr: formInputs.qualityReportNr,
      certificateOfConformity: formInputs.certificateOfConformity,
    };

    const toastId = toast.loading("Updating Quality Check...", { position: "top-right" });
    setDisabled(true);
    try {
      const res = await ItemService.updateQualityCheck(updatePayload);
      if (res?.status === 200) {
        setsucceModalData({
          title: "Success",
          successMsg: res.message || "Quality Check updated successfully",
        });
        setShowSuccessModal(true);
        setIsEditMode(false);
        loadQualityCheckDetail();
      } else {
        toast.error(res?.message || "Failed to update");
      }
    } catch (err) {
      console.log("Error updating quality check:", err);
      toast.error("Error updating quality check");
    }
    toast.dismiss(toastId);
    setDisabled(false);
  };

  const hideSuccessModal = () => {
    setShowSuccessModal(false);
    navigate(Constants.POCOLLABRATION_QUALITY_CHECK_LIST);
  };

  const getStatusBadge = (status) => {
    const statusColors = {
      "Created": "badge bg-primary",
      "In Progress": "badge bg-warning text-dark",
      "Passed": "badge bg-success",
      "Failed": "badge bg-danger",
      "Conditional": "badge bg-info",
      "Cancelled": "badge bg-secondary",
    };
    return statusColors[status] || "badge bg-secondary";
  };

  const readOnly = !isEditMode;

  const itemColumns = [
    { name: "Item Nr", selector: (row) => row.grnItemNr || row.local_id, width: "80px" },
    { name: "Material", selector: (row) => row.materialCode || "-", width: "120px" },
    { name: "Description", selector: (row) => row.materialDescription || "-", width: "180px" },
    { name: "GRN Qty", selector: (row) => row.grnQuantity || "-", width: "100px" },
    {
      name: "Inspected Qty",
      cell: (row) => (
        <InputField type="number" className="inputBox form-control-sm" name="inspectionQuantity"
          value={row.inspectionQuantity} onChange={(e) => onItemInputChange(row.local_id, "inspectionQuantity", e.target.value)} disabled={readOnly} />
      ),
      width: "120px",
    },
    {
      name: "Accepted Qty",
      cell: (row) => (
        <InputField type="number" className="inputBox form-control-sm" name="acceptedQuantity"
          value={row.acceptedQuantity} onChange={(e) => onItemInputChange(row.local_id, "acceptedQuantity", e.target.value)} disabled={readOnly} />
      ),
      width: "120px",
    },
    {
      name: "Rejected Qty",
      cell: (row) => (
        <InputField type="number" className="inputBox form-control-sm" name="rejectedQuantity"
          value={row.rejectedQuantity} onChange={(e) => onItemInputChange(row.local_id, "rejectedQuantity", e.target.value)} disabled={readOnly} />
      ),
      width: "120px",
    },
    {
      name: "Score",
      cell: (row) => (
        <span className={row.qualityScore >= 80 ? "text-success fw-bold" : row.qualityScore >= 50 ? "text-warning fw-bold" : "text-danger fw-bold"}>
          {row.qualityScore || 0}%
        </span>
      ),
      width: "80px",
    },
    {
      name: "Result",
      cell: (row) => (
        <select className="form-select form-select-sm inputBox" value={row.itemResult || ""}
          onChange={(e) => onItemInputChange(row.local_id, "itemResult", e.target.value)} disabled={readOnly}>
          <option value="">Select</option>
          <option value="Pass">Pass</option>
          <option value="Fail">Fail</option>
          <option value="Conditional">Conditional</option>
        </select>
      ),
      width: "120px",
    },
    {
      name: "Defect Notes",
      cell: (row) => (
        <InputField className="inputBox form-control-sm" name="defectDescription" value={row.defectDescription}
          onChange={(e) => onItemInputChange(row.local_id, "defectDescription", e.target.value)} placeholder="Defect details" disabled={readOnly} />
      ),
      width: "200px",
    },
  ];

  return (
    <main className="dashboard main" id="main">
      <ConfirmationLoader isPageLoading={loading} />
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <Row className="d-flex align-items-center mb-2">
              <Col xs={12} md={8}>
                <h2 className="mainTitle mb-0">Quality Check Details</h2>
                <p className="subText mb-0">
                  Inspection: <strong>{qualityCheckNr || "-"}</strong>
                  {qualityCheckData && (
                    <span className="ms-2">
                      Status: <span className={getStatusBadge(qualityCheckData.qualityCheckStatus)}>{qualityCheckData.qualityCheckStatus}</span>
                    </span>
                  )}
                </p>
              </Col>
              <Col xs={12} md={4} className="text-end">
                <button className="btn btn-sm btn-secondary me-2" onClick={() => navigate(Constants.POCOLLABRATION_QUALITY_CHECK_LIST)}>
                  <i className="bi bi-arrow-left"></i> Back
                </button>
                {readOnly ? (
                  <button className="btn btn-sm btn-primary" onClick={handleEdit}>
                    <i className="bi bi-pencil"></i> Edit
                  </button>
                ) : (
                  <>
                    <button className="btn btn-sm btn-secondary me-2" onClick={handleCancel} disabled={disabled}>
                      Cancel
                    </button>
                    <button className="btn btn-sm btn-success" onClick={handleUpdate} disabled={disabled}>
                      <i className="bi bi-check-circle"></i> Update
                    </button>
                  </>
                )}
              </Col>
            </Row>
            <hr />

            {/* ============ SECTION 1: Inspection Header ============ */}
            <div className="accordion mb-4" id="qcDetailAccordion1">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button" onClick={toggleCardVisibility1}>
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i className={`bi ${isCardVisible1 ? "bi-chevron-down" : "bi-chevron-right"}`}></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">IH</span>
                    </Col>
                    <Col xs={10} md={9} lg={9}>
                      <span className="headerTitle">Inspection Header</span>
                      <span className="subHeaderTitle">Inspection Details and Overall Result</span>
                    </Col>
                  </Row>
                </h2>
                <div className={`accordion-collapse collapse show ${isCardVisible1 ? "visible" : ""}`}>
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Inspection No." value={formInputs.qualityCheckNr || "-"} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Inspection Date" name="inspectionDate" type="date"
                          value={formInputs.inspectionDate || ""} onChange={onInputChange} disabled={readOnly} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Inspector Name" name="inspectorName"
                          value={formInputs.inspectorName || ""} onChange={onInputChange} disabled={readOnly} placeholder="Enter Inspector Name" />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">Inspection Type</label>
                        {readOnly ? (
                          <InputField className="inputBox" value={formInputs.inspectionType || "-"} disabled={true} />
                        ) : (
                          <select className="form-select inputBox" name="inspectionType" value={formInputs.inspectionType || ""} onChange={onInputChange}>
                            <option value="">Select Inspection Type</option>
                            <option value="Final Inspection">Final Inspection</option>
                            <option value="Incoming Inspection">Incoming Inspection</option>
                            <option value="In-Process Inspection">In-Process Inspection</option>
                            <option value="Pre-Shipment Inspection">Pre-Shipment Inspection</option>
                            <option value="Random Sampling">Random Sampling</option>
                          </select>
                        )}
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">Overall Result</label>
                        {readOnly ? (
                          <InputField className="inputBox" value={formInputs.overallResult || "-"} disabled={true} />
                        ) : (
                          <select className="form-select inputBox" name="overallResult" value={formInputs.overallResult || ""} onChange={onInputChange}>
                            <option value="">Select Overall Result</option>
                            <option value="Pass">Pass</option>
                            <option value="Fail">Fail</option>
                            <option value="Conditional">Conditional</option>
                          </select>
                        )}
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Quality Score" value={`${formInputs.qualityScore || 0}%`} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Status" value={formInputs.qualityCheckStatus || "-"} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <TextAreaField className="inputBox" label="Inspection Comments" name="inspectionComments"
                          value={formInputs.inspectionComments || ""} onChange={onInputChange} rows={3} disabled={readOnly} placeholder="Enter inspection comments" />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* ============ SECTION 2: Purchase Order Details ============ */}
            <div className="accordion mb-4" id="qcDetailAccordion2">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button" onClick={toggleCardVisibility2}>
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i className={`bi ${isCardVisible2 ? "bi-chevron-down" : "bi-chevron-right"}`}></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PO</span>
                    </Col>
                    <Col xs={10} md={9} lg={9}>
                      <span className="headerTitle">Purchase Order Details</span>
                      <span className="subHeaderTitle">PO Information from GRN</span>
                    </Col>
                  </Row>
                </h2>
                <div className={`accordion-collapse collapse show ${isCardVisible2 ? "visible" : ""}`}>
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="PO Number" value={formInputs.purchasingDocumentNr || "-"} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="PO Date" value={formInputs.purchasingDocumentDate || "-"} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="PO Value" value={formInputs.purchasingDocumentValue || "-"} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Currency" value={formInputs.currencyCode || "-"} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Vendor Code" value={formInputs.vendorCode || "-"} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Vendor Name" value={formInputs.vendorName || "-"} disabled={true} />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* ============ SECTION 3: GRN/Receipt Details ============ */}
            <div className="accordion mb-4" id="qcDetailAccordion3">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button" onClick={toggleCardVisibility3}>
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i className={`bi ${isCardVisible3 ? "bi-chevron-down" : "bi-chevron-right"}`}></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">GR</span>
                    </Col>
                    <Col xs={10} md={9} lg={9}>
                      <span className="headerTitle">GRN/Receipt Details</span>
                      <span className="subHeaderTitle">Goods Receipt Note Information</span>
                    </Col>
                  </Row>
                </h2>
                <div className={`accordion-collapse collapse show ${isCardVisible3 ? "visible" : ""}`}>
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="GRN Number" value={formInputs.grnNr || "-"} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="GRN Date" value={formatDateTime(formInputs.createdAt) || formInputs.grnDate || "-"} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Delivery Date" value={formInputs.deliveryDate || "-"} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="GRN Value" value={formInputs.sumOfGrn || "-"} disabled={true} />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* ============ SECTION 4: Item/Line Details ============ */}
            <div className="accordion mb-4" id="qcDetailAccordion4">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button" onClick={toggleCardVisibility4}>
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i className={`bi ${isCardVisible4 ? "bi-chevron-down" : "bi-chevron-right"}`}></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">IL</span>
                    </Col>
                    <Col xs={10} md={9} lg={9}>
                      <span className="headerTitle">Item/Line Details</span>
                      <span className="subHeaderTitle">Inspection Results per Line Item</span>
                    </Col>
                  </Row>
                </h2>
                <div className={`accordion-collapse collapse show ${isCardVisible4 ? "visible" : ""}`}>
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col xs={12}>
                        <DataTable
                          columns={itemColumns}
                          data={itemTableData}
                          pagination={false}
                          noDataComponent="No items found"
                          striped
                        />
                      </Col>
                      <Col xs={12} md={3} className="commTopButtonRightLeftPadding mt-3">
                        <InputField className="inputBox" label="Total Inspected"
                          value={itemTableData.reduce((s, i) => s + (Number(i.inspectionQuantity) || 0), 0)} disabled={true} />
                      </Col>
                      <Col xs={12} md={3} className="commTopButtonRightLeftPadding mt-3">
                        <InputField className="inputBox" label="Total Accepted"
                          value={itemTableData.reduce((s, i) => s + (Number(i.acceptedQuantity) || 0), 0)} disabled={true} />
                      </Col>
                      <Col xs={12} md={3} className="commTopButtonRightLeftPadding mt-3">
                        <InputField className="inputBox" label="Total Rejected"
                          value={itemTableData.reduce((s, i) => s + (Number(i.rejectedQuantity) || 0), 0)} disabled={true} />
                      </Col>
                      <Col xs={12} md={3} className="commTopButtonRightLeftPadding mt-3">
                        <InputField className="inputBox" label="Overall Score" value={`${formInputs.qualityScore || 0}%`} disabled={true} />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* ============ SECTION 5: Inspection/QC Inputs ============ */}
            <div className="accordion mb-4" id="qcDetailAccordion5">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button" onClick={toggleCardVisibility5}>
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i className={`bi ${isCardVisible5 ? "bi-chevron-down" : "bi-chevron-right"}`}></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">QI</span>
                    </Col>
                    <Col xs={10} md={9} lg={9}>
                      <span className="headerTitle">Inspection/QC Inputs</span>
                      <span className="subHeaderTitle">Test Methods, Equipment and Conditions</span>
                    </Col>
                  </Row>
                </h2>
                <div className={`accordion-collapse collapse show ${isCardVisible5 ? "visible" : ""}`}>
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">Inspection Method</label>
                        {readOnly ? (
                          <InputField className="inputBox" value={formInputs.inspectionMethod || "-"} disabled={true} />
                        ) : (
                          <select className="form-select inputBox" name="inspectionMethod" value={formInputs.inspectionMethod || ""} onChange={onInputChange}>
                            <option value="">Select Method</option>
                            <option value="Visual Inspection">Visual Inspection</option>
                            <option value="Dimensional Check">Dimensional Check</option>
                            <option value="Functional Test">Functional Test</option>
                            <option value="Chemical Analysis">Chemical Analysis</option>
                            <option value="Destructive Testing">Destructive Testing</option>
                            <option value="Non-Destructive Testing">Non-Destructive Testing</option>
                          </select>
                        )}
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">Sampling Method</label>
                        {readOnly ? (
                          <InputField className="inputBox" value={formInputs.samplingMethod || "-"} disabled={true} />
                        ) : (
                          <select className="form-select inputBox" name="samplingMethod" value={formInputs.samplingMethod || ""} onChange={onInputChange}>
                            <option value="">Select Sampling</option>
                            <option value="Random Sampling">Random Sampling</option>
                            <option value="Stratified Sampling">Stratified Sampling</option>
                            <option value="Systematic Sampling">Systematic Sampling</option>
                            <option value="100% Inspection">100% Inspection</option>
                          </select>
                        )}
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Sample Size" name="sampleSize" type="number"
                          value={formInputs.sampleSize || ""} onChange={onInputChange} disabled={readOnly} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Test Equipment Used" name="testEquipmentUsed"
                          value={formInputs.testEquipmentUsed || ""} onChange={onInputChange} disabled={readOnly} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Temperature" name="temperatureCondition"
                          value={formInputs.temperatureCondition || ""} onChange={onInputChange} disabled={readOnly} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Humidity" name="humidityCondition"
                          value={formInputs.humidityCondition || ""} onChange={onInputChange} disabled={readOnly} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <TextAreaField className="inputBox" label="Inspection Notes" name="inspectionNotes"
                          value={formInputs.inspectionNotes || ""} onChange={onInputChange} rows={3} disabled={readOnly} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <TextAreaField className="inputBox" label="Defect Description" name="defectDescription"
                          value={formInputs.defectDescription || ""} onChange={onInputChange} rows={3} disabled={readOnly} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <TextAreaField className="inputBox" label="Corrective Action" name="correctiveAction"
                          value={formInputs.correctiveAction || ""} onChange={onInputChange} rows={3} disabled={readOnly} />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* ============ SECTION 6: Documents ============ */}
            <div className="accordion mb-4" id="qcDetailAccordion6">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button" onClick={toggleCardVisibility6}>
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i className={`bi ${isCardVisible6 ? "bi-chevron-down" : "bi-chevron-right"}`}></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">DO</span>
                    </Col>
                    <Col xs={10} md={9} lg={9}>
                      <span className="headerTitle">Documents</span>
                      <span className="subHeaderTitle">Attached Documents and Reports</span>
                    </Col>
                  </Row>
                </h2>
                <div className={`accordion-collapse collapse show ${isCardVisible6 ? "visible" : ""}`}>
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Quality Report Number" name="qualityReportNr"
                          value={formInputs.qualityReportNr || ""} onChange={onInputChange} disabled={readOnly} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Certificate of Conformity" name="certificateOfConformity"
                          value={formInputs.certificateOfConformity || ""} onChange={onInputChange} disabled={readOnly} />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* ============ SECTION 7: Approval/Workflow ============ */}
            <div className="accordion mb-4" id="qcDetailAccordion7">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button" onClick={toggleCardVisibility7}>
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i className={`bi ${isCardVisible7 ? "bi-chevron-down" : "bi-chevron-right"}`}></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AW</span>
                    </Col>
                    <Col xs={10} md={9} lg={9}>
                      <span className="headerTitle">Approval/Workflow</span>
                      <span className="subHeaderTitle">Approval Status and History</span>
                    </Col>
                  </Row>
                </h2>
                <div className={`accordion-collapse collapse show ${isCardVisible7 ? "visible" : ""}`}>
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Approval Status" value={formInputs.approvalStatus || "Pending"} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Approved By" value={formInputs.approvedBy || "-"} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Approval Date" value={formInputs.approvalDate || "-"} disabled={true} />
                      </Col>
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                        <InputField className="inputBox" label="Approval Comments" value={formInputs.approvalComments || "-"} disabled={true} />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* ============ BOTTOM ACTION BUTTONS ============ */}
            <div className="pageFooter mb-4 pb-2">
              <Row className="rowDirection">
                <Col xs={12} md={6} lg={4}>
                  <button className="btnTable" onClick={() => navigate(Constants.POCOLLABRATION_QUALITY_CHECK_LIST)}>
                    <i className="bi bi-arrow-left"></i> Back
                  </button>
                </Col>
                {readOnly ? (
                  <Col xs={12} md={4} lg={4}>
                    <button className="btnTable" onClick={handleEdit}>
                      <i className="bi bi-pencil"></i> Edit
                    </button>
                  </Col>
                ) : (
                  <>
                    <Col xs={12} md={4} lg={4}>
                      <button className="btnTable" onClick={handleCancel} disabled={disabled}>
                        Cancel
                      </button>
                    </Col>
                    <Col xs={12} md={4} lg={4}>
                      <button className="btnTable" onClick={handleUpdate} disabled={disabled}>
                        <i className="bi bi-check-circle"></i> {disabled ? "Updating..." : "Update"}
                      </button>
                    </Col>
                  </>
                )}
              </Row>
            </div>
          </div>
        </Col>
      </Row>

      <SuccessModal
        show={getShowSuccessModal}
        onHide={hideSuccessModal}
        data={getsucceModalData}
      />
    </main>
  );
};

export default QualityCheckDetails;
